import { createStrings } from '@utils/local';

export const finishStatuses = [
  'LOCKED',
  '輸入許可',
  '配車完了',
  'D/O手配済',
  'D/O手配不要',
  '搬出手配済',
  '搬出手配不要',
  '全部発行完了',
] as const;

export const statusFLowsStrings = createStrings({
  ja: {
    DONumber: 'D/O取得番号',
    DOFile: 'D/O取得書類',
    moveOutFile: '出庫手配書類',
    DORequired: 'D/O取得番号またはD/O取得書類を入力してください',
  },
});
